import Image from 'next/image';
import { Button } from '../buttons';
import { RefreshCcw } from 'lucide-react';
import { useRouter } from 'next/router';

export default function ConnectionError() {
  const router = useRouter();
  const tryAgain = () => {
    router.reload();
  };
  return (
    <div className="flex flex-col justify-center items-center gap-4">
      <div className="w-[240px]">
        <Image
          src="/assets/connection.svg"
          alt="header"
          width={1000}
          height={1000}
        />
      </div>
      <div className="font-bold text-xl ">Something went wrong</div>
      <div className="text-center">
        There is a problem reaching our service due to a connection issue or the
        service being temporarily down.
        <br /> Please try again, or contact us if the problem persists.
      </div>
      <Button iconStart={<RefreshCcw />} onClick={tryAgain}>
        Try again
      </Button>
    </div>
  );
}
